import { render, staticRenderFns } from "./xbk.vue?vue&type=template&id=2d991f04&scoped=true&"
import script from "./xbk.vue?vue&type=script&lang=js&"
export * from "./xbk.vue?vue&type=script&lang=js&"
import style0 from "./xbk.vue?vue&type=style&index=0&id=2d991f04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d991f04",
  null
  
)

export default component.exports